module.exports = __webpack_public_path__ + "static/img/detectx_round.d4d128a1.png";